const AUTH_URL = process.env.REACT_APP_AUTH_URL || '/api/vehicle-auth';

export async function login(username, password) {
  const response = await fetch(`${AUTH_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Login failed');
  }

  return response.json();
}
